module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ISO 14001-2015.9cc2a2a3.png";